import { Chip } from '@mui/material';
import {
  BLUE_50,
  BLUE_500,
  BLUE_GRAY_400,
  GRAY_200,
  GRAY_900,
  GREEN_500,
  RED_400,
  RED_50,
  RED_500,
  TEAL_50,
  TEAL_500,
  WHITE,
} from '../../constants/Colors';
import { Delete, Edit, Visibility } from '@mui/icons-material';
import { t } from 'i18next';

export interface BakeasyChipProps {
  label?: string | '';
  clickable?: boolean;
  disabled?: boolean;
  icon?: any;
  type?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onDelete?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export function BakeasyChip(props: BakeasyChipProps) {
  let backgroundColor: any = 'primary';
  let textColor: any = 'primary';

  switch (props?.type?.toLowerCase() || props?.label?.toLowerCase()) {
    case 'pending':
      textColor = TEAL_500;
      backgroundColor = TEAL_50;
      break;
    case 'approved':
    case 'approve':
    case 'completed':
    case 'category':
    case 'subcategory':
    case 'status':
    case 'yes':
    case 'view_reply':
      textColor = GREEN_500;
      backgroundColor = TEAL_50;
      break;
    case 'rejected':
    case 'reject':
    case 'deactive':
    case 'no':
    case 'delete':
      textColor = RED_500;
      backgroundColor = RED_50;
      break;
    case 'ongoing':
      textColor = 'info';
      break;
    case 'edit':
      textColor = BLUE_500;
      backgroundColor = BLUE_50;
      break;
    case 'cancel':
      textColor = GRAY_900;
      backgroundColor = GRAY_200;
      break;
    case 'active':
      textColor = WHITE;
      backgroundColor = GREEN_500;
      break;
    case 'inactive':
      textColor = WHITE;
      backgroundColor = RED_500;
      break;
    case 'new':
      textColor = WHITE;
      backgroundColor = GREEN_500;
      break;
    case 'sent':
      textColor = WHITE;
      backgroundColor = BLUE_500;
      break;
    case 'read':
      textColor = WHITE;
      backgroundColor = BLUE_GRAY_400;
      break;
    case 'normal':
      textColor = WHITE;
      backgroundColor = BLUE_500;
      break;
    case 'urgent':
      textColor = WHITE;
      backgroundColor = RED_400;
      break;
    default:
      textColor = GRAY_900;
      backgroundColor = GRAY_200;
      break;
  }

  return (
    <Chip
      {...props}
      sx={{
        margin: 0.1,
        padding: 0.5,
        color: textColor,
        backgroundColor: backgroundColor,
      }}
      size={'small'}
      color={'primary'}
      label={props?.label && t(props?.label)}
    />
  );
}

export function BakeasyChipEdit(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={<Edit />} label={'EDIT'} />;
}

export function BakeasyChipDelete(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={<Delete />} label={'DELETE'} />;
}

export function BakeasyChipNormal(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'NORMAL'} />;
}

export function BakeasyChipUrgent(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'URGENT'} />;
}

export function BakeasyChipFilterCancel(props: BakeasyChipProps) {
  return <BakeasyChip {...props} type="cancel" />;
}

export function BakeasyChipSent(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'SENT'} />;
}

export function BakeasyChipRead(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'READ'} />;
}

export function BakeasyChipNew(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'NEW'} />;
}

export function BakeasyChipViewReply(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={<Visibility />} label={'VIEW_REPLY'} />;
}
